export class Account {

    public id: string = "0";
    public email: string;
    public displayName: string;
    public photoURL: string = 'https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2FphotoURL%2FphotoURL.png?alt=media&token=950c9ee8-3d58-4405-9a7f-4d03c4bd1fde';
    //public phoneNumber: string;
    public password: string;
    public confirm: string;
    public disabled: boolean = false;
    public claim_admin: boolean=false;
    public claim_operator: boolean= false;
    public claim_user: boolean = true;
    
    constructor() {}
}